import type { RefreshScope } from '@growthaxl/web-foundation';

export const WORKSPACE_SURFACE_ID = 'operational';

type PushRefresh = (surfaceId: string, scope: RefreshScope) => void;

export function performCapabilityTabsRefresh(
  getSurfaceId: () => string | null | undefined,
  pushRefresh: PushRefresh,
): void {
  try {
    const surfaceId = getSurfaceId();
    if (surfaceId) {
      pushRefresh(surfaceId, {});
    }
    pushRefresh(WORKSPACE_SURFACE_ID, {});
  } catch {
    // Awareness store unavailable — caller still remounts via refreshKey.
  }
}
